var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"module-index-wrapper"},_vm._l((_setup.moduleList),function(item,idx){return _c('div',{key:idx,staticClass:"finance-wrapper"},[_c(_setup.ChartTable,{attrs:{"item":item}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }